(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 94301:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(66477);
module.exports = self.fetch.bind(self);


/***/ }),

/***/ 66477:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

/* globals self */ exports.Headers = self.Headers;
exports.Request = self.Request;
exports.Response = self.Response;
exports.fetch = self.fetch;

//# sourceMappingURL=whatwg-fetch.js.map

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(23938);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 23938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/layouts/home/index.tsx
var home = __webpack_require__(91511);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(25934);
// EXTERNAL MODULE: ./src/components/navbar/index.tsx
var navbar = __webpack_require__(44824);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 104 modules
var swiper_react = __webpack_require__(29453);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(86501);
// EXTERNAL MODULE: ./src/components/icon/index.tsx + 39 modules
var icon = __webpack_require__(72287);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/shimmer.tsx
var shimmer = __webpack_require__(92042);
// EXTERNAL MODULE: ./node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(92432);
// EXTERNAL MODULE: ./src/graphql/mutations/vendor.mutation.ts
var vendor_mutation = __webpack_require__(46958);
// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(27643);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 167 modules
var motion = __webpack_require__(18716);
;// CONCATENATED MODULE: ./src/components/small-service-card/index.tsx













var SmallServiceCard = function(props) {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(props.pinned), 2), pinState = ref[0], setPinState = ref[1];
    var router = (0,next_router.useRouter)();
    var accessToken = (0,store/* default */.Z)(function(state) {
        return state.accessToken;
    });
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useMutation */.Db)(vendor_mutation/* PinVendorService */.a6), 2), pin = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useMutation */.Db)(vendor_mutation/* UnpinVendorService */.V4), 2), unpin = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col justify-start items-start gap-2 relative h-36 sm:h-52 md:h-72",
        children: [
            pinState ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    if (!!accessToken) {
                        setPinState(false);
                        dist/* default.success */.ZP.success(/*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "toast",
                            children: [
                                "You removed your interest in ",
                                props.vendorName
                            ]
                        }));
                        unpin({
                            vendorServiceId: props.id
                        }).catch(function() {
                            setPinState(true);
                            dist/* default.error */.ZP.error(/*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "toast",
                                children: [
                                    "Failed to remove interest in ",
                                    props.vendorName
                                ]
                            }));
                        });
                    } else {
                        router.push("/login");
                        dist/* default.error */.ZP.error(/*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "toast",
                            children: [
                                "You need to be logged in to show interest in",
                                " ",
                                props.vendorName
                            ]
                        }));
                    }
                },
                className: "w-fit p-2 hover:brightness-90 cursor-pointer h-fit z-[2] absolute top-0 right-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    iconName: "pinned"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    if (!!accessToken) {
                        setPinState(true);
                        dist/* default.success */.ZP.success(/*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "toast",
                            children: [
                                "Your interest in ",
                                props.vendorName,
                                " has been saved"
                            ]
                        }));
                        pin({
                            vendorServiceId: props.id
                        }).catch(function() {
                            setPinState(false);
                            dist/* default.error */.ZP.error(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "toast",
                                children: "Your interest wasn't saved"
                            }));
                        });
                    } else {
                        router.push("/login");
                        dist/* default.error */.ZP.error(/*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "toast",
                            children: [
                                "You need to be logged in to show interest in",
                                " ",
                                props.vendorName
                            ]
                        }));
                    }
                },
                className: "w-fit p-2 hover:brightness-90 cursor-pointer h-fit z-[2] absolute top-0 right-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                    iconName: "notPinned"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/profile/".concat(props.id),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: "w-full h-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative bg-inawo-green overflow-hidden w-full h-[80%] md:h-[90%] rounded-[10px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                className: "w-full relative flex justify-center items-center h-full",
                                initial: {
                                    scale: 1
                                },
                                whileHover: {
                                    scale: 1.05
                                },
                                children: props.image === "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                    iconName: "sample"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: props.image,
                                    placeholder: "blur",
                                    blurDataURL: (0,shimmer/* default */.ZP)(400, 400),
                                    objectFit: "cover",
                                    objectPosition: "center",
                                    layout: "fill",
                                    priority: props.priority,
                                    sizes: "30vw",
                                    quality: 75,
                                    alt: "".concat(props.vendorName, " ").concat(props.categoryName, " service")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "line-clamp-1 mt-2 text-xs xs:text-sm font-sfpro font-semibold text-inawo-grey",
                            children: props.vendorName
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var small_service_card = (SmallServiceCard);

// EXTERNAL MODULE: ./src/graphql/queries/home.query.ts
var home_query = __webpack_require__(74508);
// EXTERNAL MODULE: ./src/components/spinner/index.tsx
var spinner = __webpack_require__(77429);
;// CONCATENATED MODULE: ./src/components/service-carousel/index.tsx










var ServiceCarousel = function(props) {
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useQuery */.aM)({
        query: home_query/* GetVendorServiceByCategory */.J3,
        pause: !props.id,
        variables: {
            vendorServiceCategoryId: props.id,
            page: 1,
            pageSize: 20
        }
    }), 1), categoryResult = ref1[0];
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full flex flex-col justify-start items-start gap-4 my-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-between w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "font-sfpro font-light text-base xs:text-lg text-inawo-grey-500 tracking-wider uppercase",
                        children: props.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/categories/".concat(props.id),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "font-semibold text-xs xs:text-sm text-inawo-grey-500 hover:text-inawo-green-200 transition font-sfpro",
                            children: "see more"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full",
                children: categoryResult.fetching ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-36 sm:h-52 md:h-72 flex justify-center items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* Spinner */.$, {})
                }) : categoryResult.error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : categoryResult.data ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    spaceBetween: 8,
                    slidesPerView: 3.2,
                    breakpoints: {
                        // when window width is >= 320px
                        320: {
                            slidesPerView: 3.2,
                            spaceBetween: 8
                        },
                        // when window width is >= 480px
                        480: {
                            slidesPerView: 3.6,
                            spaceBetween: 10
                        },
                        // when window width is >= 640px
                        640: {
                            slidesPerView: 4.2,
                            spaceBetween: 15
                        },
                        789: {
                            slidesPerView: 4.8,
                            spaceBetween: 15
                        },
                        1280: {
                            slidesPerView: 5.4,
                            spaceBetween: 15
                        },
                        1440: {
                            slidesPerView: 6.5,
                            spaceBetween: 15
                        },
                        1840: {
                            slidesPerView: 7.5,
                            spaceBetween: 20
                        },
                        2200: {
                            slidesPerView: 8.8,
                            spaceBetween: 20
                        }
                    },
                    children: (ref = categoryResult.data) === null || ref === void 0 ? void 0 : ref.getVendorServiceByCategory.map(function(item) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(small_service_card, {
                                categoryName: props.name,
                                id: item.id,
                                pinned: (ref2 = item === null || item === void 0 ? void 0 : item.pinned) !== null && ref2 !== void 0 ? ref2 : false,
                                image: item.showcase.length > 0 ? item.showcase[0].media : "",
                                vendorName: item.service_name,
                                priority: props.priority
                            })
                        }, (0,v4/* default */.Z)());
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
            })
        ]
    });
};
/* harmony default export */ var service_carousel = (ServiceCarousel);

;// CONCATENATED MODULE: ./public/assets/sample.png
/* harmony default export */ var sample = ({"src":"/_next/static/media/sample.f5251787.png","height":149,"width":122,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAG1BMVEUnQDxNYV4mPzomPjomPjolPTkySUVBVlJfcG54J8d7AAAABXRSTlP7/r3c22o86mUAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAtSURBVAiZHYrBDQAgDIQ4ldb9JzaVDwkBHPYIFO2kxO57v6syvZL+yzxyRFwPHyMA8STlM0sAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/components/small-featured-card/index.tsx






var SmallFeaturedCard = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col justify-start items-start gap-2 relative h-44 sm:h-60 md:h-80",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/profile/".concat((ref = props === null || props === void 0 ? void 0 : props.id) !== null && ref !== void 0 ? ref : 0),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "w-full h-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative bg-inawo-green hover:brightness-90 transition overflow-hidden p-4 w-full h-full rounded-[10px] flex flex-col justify-end items-start gap-1",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: !!props.image ? props.image : sample,
                            placeholder: "blur",
                            blurDataURL: (0,shimmer/* default */.ZP)(400, 400),
                            objectFit: "cover",
                            objectPosition: "center",
                            layout: "fill",
                            quality: 75,
                            priority: true,
                            sizes: "40vw",
                            alt: "".concat((ref1 = props === null || props === void 0 ? void 0 : props.vendorName) !== null && ref1 !== void 0 ? ref1 : "", " ").concat((ref2 = props === null || props === void 0 ? void 0 : props.categoryName) !== null && ref2 !== void 0 ? ref2 : "", " service")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "bg-black/50 z-[2] px-1 py-1 uppercase font-sfpro text-xs xs:text-sm text-white font-light tracking-widest",
                            children: (ref3 = props === null || props === void 0 ? void 0 : props.categoryName) !== null && ref3 !== void 0 ? ref3 : "Unavailable"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "line-clamp-2 z-[2] text-sm xs:text-base font-sfpro font-semibold text-white",
                            children: (ref4 = props === null || props === void 0 ? void 0 : props.vendorName) !== null && ref4 !== void 0 ? ref4 : "Unavailable"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var small_featured_card = (SmallFeaturedCard);

;// CONCATENATED MODULE: ./src/components/featured-carousel/index.tsx







var FeatureCarousel = function(props) {
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full flex flex-col justify-start items-start gap-4 my-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-between w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "font-sfpro font-light text-base xs:text-lg text-inawo-grey-500 tracking-wider uppercase",
                        children: "Featured Vendors"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/search",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "font-semibold text-xs xs:text-sm text-inawo-grey-500 font-sfpro",
                            children: "Browse Vendors"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full",
                children: props.featured.fetching ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-36 sm:h-52 md:h-72 flex justify-center items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* Spinner */.$, {})
                }) : props.featured.error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : props.featured.data && !!props.featured.data.getFeaturedVendorServices ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    spaceBetween: 8,
                    slidesPerView: 2.2,
                    loop: true,
                    breakpoints: {
                        // when window width is >= 320px
                        320: {
                            slidesPerView: 2.2,
                            spaceBetween: 8
                        },
                        // when window width is >= 480px
                        480: {
                            slidesPerView: 2.6,
                            spaceBetween: 10
                        },
                        // when window width is >= 640px
                        640: {
                            slidesPerView: 3.2,
                            spaceBetween: 15
                        },
                        789: {
                            slidesPerView: 3.8,
                            spaceBetween: 15
                        },
                        1280: {
                            slidesPerView: 4.4,
                            spaceBetween: 15
                        },
                        1440: {
                            slidesPerView: 5.5,
                            spaceBetween: 15
                        },
                        1840: {
                            slidesPerView: 6.5,
                            spaceBetween: 20
                        },
                        2200: {
                            slidesPerView: 7.8,
                            spaceBetween: 20
                        }
                    },
                    children: props.featured.data.getFeaturedVendorServices.map(function(item) {
                        var ref2, ref3;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(small_featured_card, {
                                categoryName: (ref = item === null || item === void 0 ? void 0 : (ref2 = item.category) === null || ref2 === void 0 ? void 0 : ref2.Name) !== null && ref !== void 0 ? ref : "",
                                id: item === null || item === void 0 ? void 0 : item.id,
                                vendorName: (ref1 = item === null || item === void 0 ? void 0 : item.service_name) !== null && ref1 !== void 0 ? ref1 : "",
                                image: (ref3 = item === null || item === void 0 ? void 0 : item.showcase[0]) === null || ref3 === void 0 ? void 0 : ref3.media
                            })
                        }, (0,v4/* default */.Z)());
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-44 sm:h-60 md:h-80"
                })
            })
        ]
    });
};
/* harmony default export */ var featured_carousel = (FeatureCarousel);

// EXTERNAL MODULE: ./src/components/button/index.tsx
var components_button = __webpack_require__(9337);
// EXTERNAL MODULE: ./node_modules/next-urql/dist/next-urql.es.js + 1 modules
var next_urql_es = __webpack_require__(61325);
// EXTERNAL MODULE: ./src/utils/storage.ts
var storage = __webpack_require__(44920);
;// CONCATENATED MODULE: ./public/assets/banner.png
/* harmony default export */ var banner = ({"src":"/_next/static/media/banner.42d12206.png","height":500,"width":1300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAJ1BMVEUmIycAAACTi4NvWkh5e39gUEXArqZcV1F8Z1oBAQEtMzCLem7Txr+Us0x8AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAH0lEQVQImWNg42FhYGBkZGTg5mBmBzOYmJhZuRg5GQEE8QBb141rlwAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/assets/banner2.png
/* harmony default export */ var banner2 = ({"src":"/_next/static/media/banner2.03b697fb.png","height":652,"width":1285,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAElBMVEUHCwkbLzEaKSQSHBYgOzUlTUkg4PBwAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIklEQVQImRXIwREAMAzCMBvo/iv3oqeAFnxATDpAs1uicx8DggA2Iy/H6wAAAABJRU5ErkJggg=="});
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/index.tsx




















var Home = function(props) {
    var ref, ref1;
    react.useEffect(function() {
        if (props.refreshPage) {
            dist/* default.error */.ZP.error(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "toast",
                children: "Your session has expired."
            }), {
                duration: 10000
            });
            setTimeout(function() {
                window.location.reload();
            }, 2000);
        }
    }, [
        props.refreshPage
    ]);
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useQuery */.aM)({
        query: home_query/* GetInawoVendorServiceCategory */.Tw
    }), 1), categoryResult = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useQuery */.aM)({
        query: home_query/* GetFeaturedVendorServices */.Pz
    }), 1), featuredResult = ref3[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Inawo Vendors"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: "Inawo Vendors"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Inawo Vendors"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar/* default */.Z, {}),
                    categoryResult.fetching ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center items-center h-36 sm:h-52 md:h-72 ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* Spinner */.$, {})
                    }) : categoryResult.error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: "An error occured"
                    }) : !!categoryResult.data && !!categoryResult.data.getInawoVendorServiceCategory ? (ref = categoryResult.data) === null || ref === void 0 ? void 0 : ref.getInawoVendorServiceCategory.slice(0, (categoryResult === null || categoryResult === void 0 ? void 0 : categoryResult.data.getInawoVendorServiceCategory.length) / 2).map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(service_carousel, {
                            priority: true,
                            name: item.Name,
                            id: item.id
                        }, (0,v4/* default */.Z)());
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(featured_carousel, {
                        featured: featuredResult
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "my-14 overflow-hidden relative bg-gray-300 rounded-xl p-8 xs:p-16 min-h-[20rem] flex flex-col gap-4 justify-center items-end",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: banner,
                                placeholder: "blur",
                                alt: "become a vendor",
                                objectFit: "cover",
                                layout: "fill",
                                quality: 90,
                                priority: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col justify-center z-[1] items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                        className: "uppercase text-white text-md xs:text-lg font-sfpro tracking-widest text-center font-light",
                                        children: [
                                            "Become a ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            " Vendor"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/become-a-vendor",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                label: "Become a vendor",
                                                type: "button",
                                                children: "Become a Vendor"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    categoryResult.fetching ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center items-center h-36 sm:h-52 md:h-72 ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* Spinner */.$, {})
                    }) : categoryResult.error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : !!categoryResult.data && !!categoryResult.data.getInawoVendorServiceCategory ? (ref1 = categoryResult.data) === null || ref1 === void 0 ? void 0 : ref1.getInawoVendorServiceCategory.slice((categoryResult === null || categoryResult === void 0 ? void 0 : categoryResult.data.getInawoVendorServiceCategory.length) / 2, categoryResult === null || categoryResult === void 0 ? void 0 : categoryResult.data.getInawoVendorServiceCategory.length).map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(service_carousel, {
                            priority: true,
                            name: item.Name,
                            id: item.id
                        }, (0,v4/* default */.Z)());
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "my-14 overflow-hidden relative bg-inawo-green-200 rounded-xl p-8 xs:p-16 min-h-[20rem] flex flex-col gap-4 justify-center items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: banner2,
                                placeholder: "blur",
                                alt: "become a vendor",
                                objectFit: "cover",
                                layout: "fill",
                                quality: 90,
                                priority: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col justify-center items-center gap-4 z-[1]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                        className: "uppercase text-lg text-white xs:text-xl font-sfpro tracking-widest text-center font-light",
                                        children: [
                                            "Get vendors ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            " for your event"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/search",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                                label: "Explore Vendors",
                                                type: "button",
                                                children: "Explore Vendors"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
Home.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(home/* default */.Z, {
        children: page
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = ((0,next_urql_es/* withUrqlClient */.X)(function(_ssr) {
    return {
        url: "https://production.inawo.live/query",
        requestPolicy: "cache-and-network",
        fetchOptions: function() {
            return {
                headers: {
                    "x-user-token": (0,storage/* getAccessCookie */.tN)() ? "".concat((0,storage/* getAccessCookie */.tN)()) : ""
                }
            };
        }
    };
}, {
    ssr: false
})(Home));


/***/ }),

/***/ 9337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _spinner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77429);


var Button = function(param) {
    var children = param.children, type = param.type, label = param.label, handleClick = param.handleClick, disabled = param.disabled, loader = param.loader, _design = param.design, design = _design === void 0 ? "primary" : _design;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: handleClick,
        "aria-label": label,
        type: type,
        className: "".concat(design === "primary" && "w-full bg-inawo-green active:bg-inawo-green px-6 py-3 shadow flex justify-center items-center rounded-[0.75rem] transition hover:bg-inawo-green/95 disabled:cursor-not-allowed disabled:bg-inawo-grey-200", " ").concat(design === "secondary" && "w-full bg-inawo-red active:bg-inawo-red px-6 py-3 shadow flex justify-center items-center rounded-[0.75rem] transition hover:bg-inawo-red/95 disabled:cursor-not-allowed disabled:bg-inawo-grey-200"),
        disabled: disabled,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "text-white font-light text-base",
            children: loader ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_spinner__WEBPACK_IMPORTED_MODULE_1__/* .Spinner */ .$, {}) : children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 41411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ Stack; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25934);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72287);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18716);







var Stack = function(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var active = props.name.toLowerCase() === "home" ? router.pathname === "/" : router.pathname.includes(props.name.toLowerCase());
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
        passHref: true,
        href: props.link,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .motion.a */ .E.a, {
            initial: {
                scale: 1
            },
            whileHover: {
                scale: 1.05
            },
            className: "flex flex-col justify-center items-center ",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "h-9 w-9 flex justify-center items-center",
                    children: active ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        iconName: props.iconNameActive
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        iconName: props.iconNameInactive
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "font-sfpro text-xs xs:text-sm ".concat(active ? "text-inawo-grey-500 font-semibold" : "text-inawo-black font-light"),
                    children: props.name
                })
            ]
        })
    });
};
var Stacklist = [
    {
        name: "Home",
        link: "/",
        iconNameInactive: "home",
        iconNameActive: "homeActive"
    },
    {
        name: "Search",
        link: "/search",
        iconNameInactive: "search",
        iconNameActive: "searchActive"
    },
    {
        name: "Interests",
        link: "/interests",
        iconNameInactive: "interest",
        iconNameActive: "interestActive"
    },
    {
        name: "Vendors",
        link: "/vendors",
        iconNameInactive: "vendors",
        iconNameActive: "vendorsActive"
    }, 
];
var FloatingBarHome = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "fixed bg-white w-full px-6 py-2 bottom-0 left-0 right-0 z-10 flex justify-center items-center gap-8 sm:gap-12",
        children: Stacklist.map(function(item) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Stack, {
                name: item.name,
                link: item.link,
                iconNameActive: item.iconNameActive,
                iconNameInactive: item.iconNameInactive
            }, (0,uuid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)());
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FloatingBarHome);


/***/ }),

/***/ 44824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var jwt_decode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96245);
/* harmony import */ var _components_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72287);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _hooks_useLockedBody__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54473);
/* harmony import */ var _utils_storage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44920);
/* harmony import */ var src_store__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27643);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(21190);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(18716);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(25934);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(92432);
/* harmony import */ var _graphql_queries_vendor_query__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19057);
/* harmony import */ var _utils_auth__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62619);















var Navbar = function() {
    var ref, ref1;
    var accessToken = (0,src_store__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(state) {
        return state.accessToken;
    });
    var accessTokenDecoded = !!accessToken ? (0,jwt_decode__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(accessToken) : null;
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,urql__WEBPACK_IMPORTED_MODULE_12__/* .useQuery */ .aM)({
        query: _graphql_queries_vendor_query__WEBPACK_IMPORTED_MODULE_9__/* .GetMyVendorProfile */ .T8,
        pause: !accessToken
    }), 1), vendorsProfileResult = ref2[0];
    if (!vendorsProfileResult.fetching && ((ref = vendorsProfileResult.error) === null || ref === void 0 ? void 0 : ref.message.includes("unauthenticated")) && !!(accessTokenDecoded === null || accessTokenDecoded === void 0 ? void 0 : accessTokenDecoded.exp) && Date.now() >= (accessTokenDecoded === null || accessTokenDecoded === void 0 ? void 0 : accessTokenDecoded.exp) * 1000) {
        (0,_utils_auth__WEBPACK_IMPORTED_MODULE_10__/* .refreshOnClientError */ .WD)();
    }
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), show = ref3[0], setShow = ref3[1];
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(!accessToken), 2), search = ref4[0], setSearch = ref4[1];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        setShow(true);
        if (!accessToken) {
            setSearch(true);
        }
    }, [
        accessToken
    ]);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var onPropsPage = router.pathname.includes("interest");
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), showDrawer = ref5[0], setShowDrawer = ref5[1];
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_hooks_useLockedBody__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(), 2), setLocked = ref6[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_13__/* .AnimatePresence */ .M, {
                exitBeforeEnter: true,
                children: showDrawer ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_14__/* .motion.div */ .E.div, {
                    initial: {
                        x: 100,
                        opacity: 0
                    },
                    animate: {
                        x: 0,
                        opacity: 1
                    },
                    exit: {
                        x: -100,
                        opacity: 0
                    },
                    className: "top-0 left-0 h-screen z-20 fixed w-screen bg-inawo-green py-8 pr-8 pl-14 flex flex-col justify-start items-start gap-6",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-8 h-8 grid scale-150 transform place-items-center place-self-end justify-self-end self-end cursor-pointer mb-4",
                            onClick: function() {
                                setLocked(false);
                                setShowDrawer(false);
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                iconName: "close"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "font-sfpro text-white font-medium text-5xl md:text-7xl flex flex-col justify-start items-start gap-12",
                            children: !!accessToken && show ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    ((ref1 = vendorsProfileResult.data) === null || ref1 === void 0 ? void 0 : ref1.getMyVendorProfile.id) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        href: "/dashboard",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                            className: "transition hover:text-inawo-gold",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-inawo-gold text-base",
                                                    children: "01"
                                                }),
                                                "Dashboard"
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        href: "/become-a-vendor",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                            className: "transition hover:text-inawo-gold",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-inawo-gold text-base",
                                                    children: "01"
                                                }),
                                                "Become a Vendor"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "cursor-pointer transition hover:text-inawo-gold",
                                        onClick: function() {
                                            router.push("/login");
                                            //setLocked(false);
                                            (0,_utils_storage__WEBPACK_IMPORTED_MODULE_7__/* .deleteAccessCookie */ .i)();
                                            (0,_utils_storage__WEBPACK_IMPORTED_MODULE_7__/* .deleteRefreshCookie */ .V6)();
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-inawo-gold text-base",
                                                children: "02"
                                            }),
                                            "Log out"
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        href: "/login",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                            className: "transition hover:text-inawo-gold",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-inawo-gold text-base",
                                                    children: "01"
                                                }),
                                                "Sign In"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        href: "/register",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                            className: "transition hover:text-inawo-gold",
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-inawo-gold text-base",
                                                    children: "02"
                                                }),
                                                "Sign Up"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        href: "/register?next=become-a-vendor",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                            className: "transition hover:text-inawo-gold",
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-inawo-gold text-base",
                                                    children: "03"
                                                }),
                                                "Become a Vendor"
                                            ]
                                        })
                                    }),
                                    " "
                                ]
                            })
                        })
                    ]
                }, (0,uuid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)()) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex justify-between items-center w-full py-4 pt-8",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-start gap-1 items-end font-sfpro font-semibold text-xs text-inawo-grey",
                        children: onPropsPage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex justify-start items-end",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    iconName: "pinGreen"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "font-sfpro font-semibold text-xl md:text-2xl",
                                    children: "Interests"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "cursor-pointer",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            iconName: "logoGreen"
                                        })
                                    })
                                }),
                                "Vendors"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-center items-center gap-1",
                        children: [
                            search && show && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                href: "/search",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "cursor-pointer p-2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        iconName: "search"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "cursor-pointer p-2",
                                onClick: function() {
                                    setLocked(true);
                                    setShowDrawer(true);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    iconName: "burger"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Navbar);


/***/ }),

/***/ 77429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Spinner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var Spinner = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        version: "1.1",
        className: "w-8",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 80 80",
        xmlSpace: "preserve",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#34544F",
                d: "M10,40c0,0,0-0.4,0-1.1c0-0.3,0-0.8,0-1.3c0-0.3,0-0.5,0-0.8c0-0.3,0.1-0.6,0.1-0.9c0.1-0.6,0.1-1.4,0.2-2.1 c0.2-0.8,0.3-1.6,0.5-2.5c0.2-0.9,0.6-1.8,0.8-2.8c0.3-1,0.8-1.9,1.2-3c0.5-1,1.1-2,1.7-3.1c0.7-1,1.4-2.1,2.2-3.1 c1.6-2.1,3.7-3.9,6-5.6c2.3-1.7,5-3,7.9-4.1c0.7-0.2,1.5-0.4,2.2-0.7c0.7-0.3,1.5-0.3,2.3-0.5c0.8-0.2,1.5-0.3,2.3-0.4l1.2-0.1 l0.6-0.1l0.3,0l0.1,0l0.1,0l0,0c0.1,0-0.1,0,0.1,0c1.5,0,2.9-0.1,4.5,0.2c0.8,0.1,1.6,0.1,2.4,0.3c0.8,0.2,1.5,0.3,2.3,0.5 c3,0.8,5.9,2,8.5,3.6c2.6,1.6,4.9,3.4,6.8,5.4c1,1,1.8,2.1,2.7,3.1c0.8,1.1,1.5,2.1,2.1,3.2c0.6,1.1,1.2,2.1,1.6,3.1 c0.4,1,0.9,2,1.2,3c0.3,1,0.6,1.9,0.8,2.7c0.2,0.9,0.3,1.6,0.5,2.4c0.1,0.4,0.1,0.7,0.2,1c0,0.3,0.1,0.6,0.1,0.9 c0.1,0.6,0.1,1,0.1,1.4C74,39.6,74,40,74,40c0.2,2.2-1.5,4.1-3.7,4.3s-4.1-1.5-4.3-3.7c0-0.1,0-0.2,0-0.3l0-0.4c0,0,0-0.3,0-0.9 c0-0.3,0-0.7,0-1.1c0-0.2,0-0.5,0-0.7c0-0.2-0.1-0.5-0.1-0.8c-0.1-0.6-0.1-1.2-0.2-1.9c-0.1-0.7-0.3-1.4-0.4-2.2 c-0.2-0.8-0.5-1.6-0.7-2.4c-0.3-0.8-0.7-1.7-1.1-2.6c-0.5-0.9-0.9-1.8-1.5-2.7c-0.6-0.9-1.2-1.8-1.9-2.7c-1.4-1.8-3.2-3.4-5.2-4.9 c-2-1.5-4.4-2.7-6.9-3.6c-0.6-0.2-1.3-0.4-1.9-0.6c-0.7-0.2-1.3-0.3-1.9-0.4c-1.2-0.3-2.8-0.4-4.2-0.5l-2,0c-0.7,0-1.4,0.1-2.1,0.1 c-0.7,0.1-1.4,0.1-2,0.3c-0.7,0.1-1.3,0.3-2,0.4c-2.6,0.7-5.2,1.7-7.5,3.1c-2.2,1.4-4.3,2.9-6,4.7c-0.9,0.8-1.6,1.8-2.4,2.7 c-0.7,0.9-1.3,1.9-1.9,2.8c-0.5,1-1,1.9-1.4,2.8c-0.4,0.9-0.8,1.8-1,2.6c-0.3,0.9-0.5,1.6-0.7,2.4c-0.2,0.7-0.3,1.4-0.4,2.1 c-0.1,0.3-0.1,0.6-0.2,0.9c0,0.3-0.1,0.6-0.1,0.8c0,0.5-0.1,0.9-0.1,1.3C10,39.6,10,40,10,40z",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                    attributeType: "xml",
                    attributeName: "transform",
                    type: "rotate",
                    from: "0 40 40",
                    to: "360 40 40",
                    dur: "0.8s",
                    repeatCount: "indefinite"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#000",
                d: "M62,40.1c0,0,0,0.2-0.1,0.7c0,0.2,0,0.5-0.1,0.8c0,0.2,0,0.3,0,0.5c0,0.2-0.1,0.4-0.1,0.7 c-0.1,0.5-0.2,1-0.3,1.6c-0.2,0.5-0.3,1.1-0.5,1.8c-0.2,0.6-0.5,1.3-0.7,1.9c-0.3,0.7-0.7,1.3-1,2.1c-0.4,0.7-0.9,1.4-1.4,2.1 c-0.5,0.7-1.1,1.4-1.7,2c-1.2,1.3-2.7,2.5-4.4,3.6c-1.7,1-3.6,1.8-5.5,2.4c-2,0.5-4,0.7-6.2,0.7c-1.9-0.1-4.1-0.4-6-1.1 c-1.9-0.7-3.7-1.5-5.2-2.6c-1.5-1.1-2.9-2.3-4-3.7c-0.6-0.6-1-1.4-1.5-2c-0.4-0.7-0.8-1.4-1.2-2c-0.3-0.7-0.6-1.3-0.8-2 c-0.2-0.6-0.4-1.2-0.6-1.8c-0.1-0.6-0.3-1.1-0.4-1.6c-0.1-0.5-0.1-1-0.2-1.4c-0.1-0.9-0.1-1.5-0.1-2c0-0.5,0-0.7,0-0.7 s0,0.2,0.1,0.7c0.1,0.5,0,1.1,0.2,2c0.1,0.4,0.2,0.9,0.3,1.4c0.1,0.5,0.3,1,0.5,1.6c0.2,0.6,0.4,1.1,0.7,1.8 c0.3,0.6,0.6,1.2,0.9,1.9c0.4,0.6,0.8,1.3,1.2,1.9c0.5,0.6,1,1.3,1.6,1.8c1.1,1.2,2.5,2.3,4,3.2c1.5,0.9,3.2,1.6,5,2.1 c1.8,0.5,3.6,0.6,5.6,0.6c1.8-0.1,3.7-0.4,5.4-1c1.7-0.6,3.3-1.4,4.7-2.4c1.4-1,2.6-2.1,3.6-3.3c0.5-0.6,0.9-1.2,1.3-1.8 c0.4-0.6,0.7-1.2,1-1.8c0.3-0.6,0.6-1.2,0.8-1.8c0.2-0.6,0.4-1.1,0.5-1.7c0.1-0.5,0.2-1,0.3-1.5c0.1-0.4,0.1-0.8,0.1-1.2 c0-0.2,0-0.4,0.1-0.5c0-0.2,0-0.4,0-0.5c0-0.3,0-0.6,0-0.8c0-0.5,0-0.7,0-0.7c0-1.1,0.9-2,2-2s2,0.9,2,2C62,40,62,40.1,62,40.1z",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                    attributeType: "xml",
                    attributeName: "transform",
                    type: "rotate",
                    from: "0 40 40",
                    to: "-360 40 40",
                    dur: "0.6s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};



/***/ }),

/***/ 46958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qe": function() { return /* binding */ CreateMyVendorService; },
/* harmony export */   "V4": function() { return /* binding */ UnpinVendorService; },
/* harmony export */   "XB": function() { return /* binding */ CancelVendorServiceBookings; },
/* harmony export */   "a6": function() { return /* binding */ PinVendorService; },
/* harmony export */   "az": function() { return /* binding */ BookVendorService; },
/* harmony export */   "ge": function() { return /* binding */ CreateMyVendorServiceShowcases; },
/* harmony export */   "nB": function() { return /* binding */ CreateMyVendorProfile; }
/* harmony export */ });
/* unused harmony exports RateVendorService, DeleteMyVendorService, CreateMyVendorServiceShowcase, DeleteMyVendorServiceShowcase */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26997);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation PinVendorService($vendorServiceId: UUID!) {\n    pinVendorService(vendorServiceId: $vendorServiceId)\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation UnPinVendorService($vendorServiceId: UUID!) {\n    unPinVendorService(vendorServiceId: $vendorServiceId)\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation BookVendorService(\n    $vendorServiceId: UUID!\n    $date: Time!\n    $eventUuid: UUID\n  ) {\n    bookVendorService(\n      vendorServiceId: $vendorServiceId\n      date: $date\n      eventUUID: $eventUuid\n    )\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation RateVendorService(\n    $vendorServiceId: UUID!\n    $rating: Int!\n    $comment: String!\n    $bookingId: UUID!\n  ) {\n    rateVendorService(\n      vendorServiceId: $vendorServiceId\n      rating: $rating\n      comment: $comment\n      bookingId: $bookingId\n    ) {\n      id\n      vendors_id\n      vendor_service_id\n      vendor_bookings_id\n      comment\n      rating\n      user_uuid\n      event_uuid\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CreateMyVendorService($req: CreateMyVendorServiceReq!) {\n    createMyVendorService(req: $req) {\n      id\n      service_name\n      vendors_id\n      vendor_service_category_id\n      category {\n        id\n        Name\n      }\n      email\n      phone_number\n      description\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CreateMyVendorProfile($req: CreateMyVendorProfileReq!) {\n    createMyVendorProfile(req: $req) {\n      id\n      user_uuid\n      brand_name\n      description\n      phone_number\n      email\n      address\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CancelVendorServiceBookings($bookingId: UUID!) {\n    cancelVendorServiceBookings(bookingId: $bookingId)\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation DeleteMyVendorService($vendorServiceId: UUID!) {\n    deleteMyVendorService(vendorServiceId: $vendorServiceId)\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CreateMyVendorServiceShowcase($req: CreateMyVendorServiceShowcase!) {\n    createMyVendorServiceShowcase(req: $req) {\n      id\n      vendors_id\n      vendor_service_category_id\n      vendor_service_id\n      name\n      media\n      description\n      tags\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation DeleteMyVendorServiceShowcase(\n    $serviceId: UUID!\n    $showcaseId: UUID!\n  ) {\n    deleteMyVendorServiceShowcase(\n      serviceId: $serviceId\n      showcaseId: $showcaseId\n    )\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CreateMyVendorServiceShowcases(\n    $serviceId: UUID!\n    $req: [CreateMyVendorServiceShowcase!]!\n  ) {\n    createMyVendorServiceShowcases(serviceId: $serviceId, req: $req)\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

var PinVendorService = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var UnpinVendorService = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
var BookVendorService = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
var RateVendorService = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());
var CreateMyVendorService = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4());
var CreateMyVendorProfile = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject5());
var CancelVendorServiceBookings = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject6());
var DeleteMyVendorService = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject7());
var CreateMyVendorServiceShowcase = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject8());
var DeleteMyVendorServiceShowcase = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject9());
var CreateMyVendorServiceShowcases = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject10());


/***/ }),

/***/ 74508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J3": function() { return /* binding */ GetVendorServiceByCategory; },
/* harmony export */   "Pz": function() { return /* binding */ GetFeaturedVendorServices; },
/* harmony export */   "Tw": function() { return /* binding */ GetInawoVendorServiceCategory; },
/* harmony export */   "n5": function() { return /* binding */ User; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26997);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetInawoVendorServiceCategory {\n    getInawoVendorServiceCategory {\n      id\n      Name\n      Description\n      Images\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetVendorServiceByCategory(\n    $vendorServiceCategoryId: UUID!\n    $page: Int\n    $pageSize: Int\n  ) {\n    getVendorServiceByCategory(\n      vendorServiceCategoryId: $vendorServiceCategoryId\n    ) {\n      id\n      interests\n      vendors_id\n      price {\n        currency\n        amount\n      }\n      vendor_service_category_id\n      category {\n        id\n        Name\n      }\n      service_name\n      pinned\n      description\n      phone_number\n      rating\n      email\n      address\n      showcase(page: $page, pageSize: $pageSize) {\n        id\n        vendors_id\n        vendor_service_id\n        vendor_service_category_id\n        media\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetFeaturedVendorServices($page: Int, $pageSize: Int) {\n    getFeaturedVendorServices {\n      id\n      vendors_id\n      vendor_service_category_id\n      service_name\n      pinned\n      category {\n        Name\n      }\n      showcase(page: $page, pageSize: $pageSize) {\n        id\n        media\n        name\n        vendor_service_id\n        vendors_id\n        vendor_service_category_id\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query User {\n    user {\n      id\n      image\n      email\n      phone_number\n      first_name\n      last_name\n      title\n      uuid\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var GetInawoVendorServiceCategory = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var GetVendorServiceByCategory = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
var GetFeaturedVendorServices = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
var User = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());


/***/ }),

/***/ 91511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_floating_bar_home__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41411);
/* harmony import */ var _utils_storage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44920);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86501);






var HomeLayout = function(props) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), show = ref[0], setShow = ref[1];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        setShow(true);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hot_toast__WEBPACK_IMPORTED_MODULE_4__/* .Toaster */ .x7, {
                position: "bottom-center",
                reverseOrder: true,
                containerStyle: {
                    zIndex: "2147483647",
                    isolation: "isolate",
                    transformStyle: "preserve-3d",
                    transform: "translateZ(1000px)",
                    bottom: 90
                },
                toastOptions: {
                    duration: 2000,
                    success: {
                        style: {
                            background: "#376C65",
                            border: "0.5px dashed #376C65",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "20px 50px",
                            fontFamily: "SF Pro Text",
                            fontStyle: "normal",
                            fontWeight: "600",
                            fontSize: "12px",
                            textAlign: "center",
                            color: "#fff",
                            borderRadius: "15px",
                            zIndex: "2147483647",
                            isolation: "isolate",
                            transformStyle: "preserve-3d",
                            transform: "trasnslateZ(1000px)"
                        }
                    },
                    error: {
                        style: {
                            background: "#6C3737",
                            border: "0.5px dashed #6C3737",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "12px 8px",
                            fontFamily: "SF Pro Text",
                            fontStyle: "normal",
                            fontWeight: "400",
                            fontSize: "12px",
                            lineHeight: "19px",
                            textAlign: "center",
                            color: "#fff",
                            borderRadius: "15px",
                            zIndex: "2147483647",
                            isolation: "isolate",
                            transformStyle: "preserve-3d",
                            transform: "trasnslateZ(1000px)"
                        }
                    }
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "z-[0] w-full relative overflow-x-hidden bg-white",
                children: [
                    show && (0,_utils_storage__WEBPACK_IMPORTED_MODULE_3__/* .hasAccessCookie */ .rh)() ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_floating_bar_home__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "z-[-1] bg-inawo-bg-green-top-bg w-screen fixed top-0 h-1/3"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full max-w-[1300px] mx-auto z-[3] pb-24 px-4 md:px-8 flex flex-col justify-start min-h-full items-center gap-1",
                        children: props.children
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "z-[-1] bg-inawo-bg-grey-bottom-bottom-bg w-screen fixed bottom-0 h-1/5"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HomeLayout);


/***/ }),

/***/ 92042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports shimmer, toBase64 */
var shimmer = function(w, h) {
    return '\n<svg width="'.concat(w, '" height="').concat(h, '" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n  <defs>\n    <linearGradient id="g">\n      <stop stop-color="#333" offset="20%" />\n      <stop stop-color="#222" offset="50%" />\n      <stop stop-color="#333" offset="70%" />\n    </linearGradient>\n  </defs>\n  <rect width="').concat(w, '" height="').concat(h, '" fill="#333" />\n  <rect id="r" width="').concat(w, '" height="').concat(h, '" fill="url(#g)" />\n  <animate xlink:href="#r" attributeName="x" from="-').concat(w, '" to="').concat(w, '" dur="1s" repeatCount="indefinite"  />\n</svg>');
};
var toBase64 = function(str) {
    return  false ? 0 : window.btoa(str);
};
var blurDataUrl = function(w, h) {
    return "data:image/svg+xml;base64,".concat(toBase64(shimmer(w, h)));
};
/* harmony default export */ __webpack_exports__["ZP"] = (blurDataUrl);


/***/ }),

/***/ 36902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ create$1; }
});

// UNUSED EXPORTS: createStore, useStore

;// CONCATENATED MODULE: ./node_modules/zustand/esm/vanilla.js
const createStoreImpl = (createState) => {
  let state;
  const listeners = /* @__PURE__ */ new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (nextState !== state) {
      const previousState = state;
      state = replace ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => listeners.clear();
  const api = { setState, getState, subscribe, destroy };
  state = createState(setState, getState, api);
  return api;
};
const createStore = (createState) => createState ? createStoreImpl(createState) : createStoreImpl;



// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/zustand/node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(28258);
;// CONCATENATED MODULE: ./node_modules/zustand/esm/index.js






const { useSyncExternalStoreWithSelector } = with_selector;
function useStore(api, selector = api.getState, equalityFn) {
  const slice = useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getState, selector, equalityFn);
  (0,react.useDebugValue)(slice);
  return slice;
}
const createImpl = (createState) => {
  const api = typeof createState === "function" ? createStore(createState) : createState;
  const useBoundStore = (selector, equalityFn) => useStore(api, selector, equalityFn);
  Object.assign(useBoundStore, api);
  return useBoundStore;
};
const create = (createState) => createState ? createImpl(createState) : createImpl;
var create$1 = create;




/***/ }),

/***/ 26849:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(67294);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 49743:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h=__webpack_require__(67294),n=__webpack_require__(54652);function p(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var q="function"===typeof Object.is?Object.is:p,r=n.useSyncExternalStore,t=h.useRef,u=h.useEffect,v=h.useMemo,w=h.useDebugValue;
exports.useSyncExternalStoreWithSelector=function(a,b,e,l,g){var c=t(null);if(null===c.current){var f={hasValue:!1,value:null};c.current=f}else f=c.current;c=v(function(){function a(a){if(!c){c=!0;d=a;a=l(a);if(void 0!==g&&f.hasValue){var b=f.value;if(g(b,a))return k=b}return k=a}b=k;if(q(d,a))return b;var e=l(a);if(void 0!==g&&g(b,e))return b;d=a;return k=e}var c=!1,d,k,m=void 0===e?null:e;return[function(){return a(b())},null===m?void 0:function(){return a(m())}]},[b,e,l,g]);var d=r(a,c[0],c[1]);
u(function(){f.hasValue=!0;f.value=d},[d]);w(d);return d};


/***/ }),

/***/ 54652:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(26849);
} else {}


/***/ }),

/***/ 28258:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(49743);
} else {}


/***/ }),

/***/ 47568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 21190:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ AnimatePresence; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/process.mjs
var process = __webpack_require__(49304);
// EXTERNAL MODULE: ./node_modules/framesync/dist/es/index.mjs + 2 modules
var es = __webpack_require__(54735);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-isomorphic-effect.mjs
var use_isomorphic_effect = __webpack_require__(58868);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/use-is-mounted.mjs



function useIsMounted() {
    var isMounted = (0,react.useRef)(false);
    (0,use_isomorphic_effect/* useIsomorphicLayoutEffect */.L)(function () {
        isMounted.current = true;
        return function () {
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/use-force-update.mjs





function useForceUpdate() {
    var isMounted = useIsMounted();
    var _a = (0,tslib_es6/* __read */.CR)((0,react.useState)(0), 2), forcedRenderCount = _a[0], setForcedRenderCount = _a[1];
    var forceRender = (0,react.useCallback)(function () {
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [forcedRenderCount]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */
    var deferredForceRender = (0,react.useCallback)(function () { return es/* default.postRender */.ZP.postRender(forceRender); }, [forceRender]);
    return [deferredForceRender, forcedRenderCount];
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/PresenceContext.mjs
var PresenceContext = __webpack_require__(240);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(96681);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-id.mjs
var use_id = __webpack_require__(76316);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/PresenceChild.mjs







var PresenceChild = function (_a) {
    var children = _a.children, initial = _a.initial, isPresent = _a.isPresent, onExitComplete = _a.onExitComplete, custom = _a.custom, presenceAffectsLayout = _a.presenceAffectsLayout;
    var presenceChildren = (0,use_constant/* useConstant */.h)(newChildrenMap);
    var id = (0,use_id/* useId */.M)();
    var context = (0,react.useMemo)(function () { return ({
        id: id,
        initial: initial,
        isPresent: isPresent,
        custom: custom,
        onExitComplete: function (childId) {
            var e_1, _a;
            presenceChildren.set(childId, true);
            try {
                for (var _b = (0,tslib_es6/* __values */.XA)(presenceChildren.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var isComplete = _c.value;
                    if (!isComplete)
                        return; // can stop searching when any is incomplete
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete();
        },
        register: function (childId) {
            presenceChildren.set(childId, false);
            return function () { return presenceChildren.delete(childId); };
        },
    }); }, 
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    presenceAffectsLayout ? undefined : [isPresent]);
    (0,react.useMemo)(function () {
        presenceChildren.forEach(function (_, key) { return presenceChildren.set(key, false); });
    }, [isPresent]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */
    react.useEffect(function () {
        !isPresent && !presenceChildren.size && (onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete());
    }, [isPresent]);
    return (react.createElement(PresenceContext/* PresenceContext.Provider */.O.Provider, { value: context }, children));
};
function newChildrenMap() {
    return new Map();
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/LayoutGroupContext.mjs
var LayoutGroupContext = __webpack_require__(25364);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-unmount-effect.mjs
var use_unmount_effect = __webpack_require__(65411);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs











var getChildKey = function (child) { return child.key || ""; };
function updateChildLookup(children, allChildren) {
    children.forEach(function (child) {
        var key = getChildKey(child);
        allChildren.set(key, child);
    });
}
function onlyElements(children) {
    var filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    react.Children.forEach(children, function (child) {
        if ((0,react.isValidElement)(child))
            filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */
var AnimatePresence = function (_a) {
    var children = _a.children, custom = _a.custom, _b = _a.initial, initial = _b === void 0 ? true : _b, onExitComplete = _a.onExitComplete, exitBeforeEnter = _a.exitBeforeEnter, _c = _a.presenceAffectsLayout, presenceAffectsLayout = _c === void 0 ? true : _c;
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    var _d = (0,tslib_es6/* __read */.CR)(useForceUpdate(), 1), forceRender = _d[0];
    var forceRenderLayoutGroup = (0,react.useContext)(LayoutGroupContext/* LayoutGroupContext */.p).forceRender;
    if (forceRenderLayoutGroup)
        forceRender = forceRenderLayoutGroup;
    var isMounted = useIsMounted();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    var filteredChildren = onlyElements(children);
    var childrenToRender = filteredChildren;
    var exiting = new Set();
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    var presentChildren = (0,react.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    var allChildren = (0,react.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    var isInitialRender = (0,react.useRef)(true);
    (0,use_isomorphic_effect/* useIsomorphicLayoutEffect */.L)(function () {
        isInitialRender.current = false;
        updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0,use_unmount_effect/* useUnmountEffect */.z)(function () {
        isInitialRender.current = true;
        allChildren.clear();
        exiting.clear();
    });
    if (isInitialRender.current) {
        return (react.createElement(react.Fragment, null, childrenToRender.map(function (child) { return (react.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, initial: initial ? undefined : false, presenceAffectsLayout: presenceAffectsLayout }, child)); })));
    }
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(childrenToRender), false);
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    var presentKeys = presentChildren.current.map(getChildKey);
    var targetKeys = filteredChildren.map(getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    var numPresent = presentKeys.length;
    for (var i = 0; i < numPresent; i++) {
        var key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1) {
            exiting.add(key);
        }
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (exitBeforeEnter && exiting.size) {
        childrenToRender = [];
    }
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exiting.forEach(function (key) {
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1)
            return;
        var child = allChildren.get(key);
        if (!child)
            return;
        var insertionIndex = presentKeys.indexOf(key);
        var onExit = function () {
            allChildren.delete(key);
            exiting.delete(key);
            // Remove this child from the present children
            var removeIndex = presentChildren.current.findIndex(function (presentChild) { return presentChild.key === key; });
            presentChildren.current.splice(removeIndex, 1);
            // Defer re-rendering until all exiting children have indeed left
            if (!exiting.size) {
                presentChildren.current = filteredChildren;
                if (isMounted.current === false)
                    return;
                forceRender();
                onExitComplete && onExitComplete();
            }
        };
        childrenToRender.splice(insertionIndex, 0, react.createElement(PresenceChild, { key: getChildKey(child), isPresent: false, onExitComplete: onExit, custom: custom, presenceAffectsLayout: presenceAffectsLayout }, child));
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map(function (child) {
        var key = child.key;
        return exiting.has(key) ? (child) : (react.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, presenceAffectsLayout: presenceAffectsLayout }, child));
    });
    if (process/* env */.O !== "production" &&
        exitBeforeEnter &&
        childrenToRender.length > 1) {
        console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour.");
    }
    return (react.createElement(react.Fragment, null, exiting.size
        ? childrenToRender
        : childrenToRender.map(function (child) { return (0,react.cloneElement)(child); })));
};




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [379,88,655,675,453,237,697,774,888,377], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);